import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import { MdOutlinePriceCheck, MdOutlineDescription, MdOutlineHistory, MdOutlineReceiptLong } from "react-icons/md";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import PricingTab from "../../components/billing/PricingTab";
import CreateInvoiceTab from "../../components/billing/CreateInvoiceTab";
import InvoiceTemplateTab from "../../components/billing/InvoiceTemplateTab";
import InvoiceHistoryTab from "../../components/billing/InvoiceHistoryTab";

const TABS = [
    { key: "pricing", label: "Pricing", icon: MdOutlinePriceCheck },
    { key: "invoice", label: "Create Invoice", icon: MdOutlineReceiptLong },
    { key: "template", label: "Invoice Template", icon: MdOutlineDescription },
    { key: "history", label: "Invoice History", icon: MdOutlineHistory },
];

const Billing = () => {
    const [tab, setTab] = useState("pricing");
    return (
        <div className="h-screen flex bg-gray-50 overflow-hidden">
            <Sidebar />
            <div className="flex-1 overflow-y-auto p-6">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-slate-900 flex items-center gap-2">
                            <LiaFileInvoiceDollarSolid className="text-blue-900" />
                            Billing
                        </h1>
                        <p className="text-sm text-slate-500 mt-1">
                            Manage feature pricing, invoice branding, and payment history.
                        </p>
                    </div>
                </div>

                <div className="flex gap-1 border-b border-gray-200 mb-6">
                    {TABS.map(({ key, label, icon: Icon }) => (
                        <button
                            key={key}
                            onClick={() => setTab(key)}
                            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${tab === key ? "border-blue-900 text-blue-900" : "border-transparent text-gray-500 hover:text-gray-700"}`}
                        >
                            <Icon size={16} />{label}
                        </button>
                    ))}
                </div>

                {tab === "pricing" && <PricingTab />}
                {tab === "invoice" && <CreateInvoiceTab />}
                {tab === "template" && <InvoiceTemplateTab />}
                {tab === "history" && <InvoiceHistoryTab />}
            </div>
        </div>
    );
};

export default Billing;